import { Fragment, memo } from 'react';
import { CalendarDate } from '../CalendarDate';
import { GradientDivider } from '../../gradients/GradientDivider';
import Stack from '@mui/material/Stack';
import { EventKeyed } from 'src/contexts/EventsLazyContext';
import { useTheme } from '@mui/material/styles';

export type CalendarDayProps = {
  date: Date;
  events: EventKeyed[];
  height?: string;
};

function CalendarDayUnmemoized({
  date,
  events,
  height = '100%',
}: CalendarDayProps) {
  const theme = useTheme();
  return (
    <Stack
      overflow={'auto'}
      height={height}
      sx={{
        mx: 1,
        pt: 1,
        width: '288px',
      }}
    >
      <CalendarDate date={date} />
      <GradientDivider color="primary" />
      <Stack
        overflow={'auto'}
        flex={1}
        sx={theme.palette.scrollbars.invisible}
        spacing={4}
      >
        {events.map(({ key, Element }) => {
          return <Fragment key={key}>{Element}</Fragment>;
        })}
      </Stack>
    </Stack>
  );
}

export const CalendarDay = memo(CalendarDayUnmemoized);
